export const Bio = {
  name: "Aman Wairagkar",
  roles: ["Web Developer", "Software Developer", "AI Enthusiast"],
  description:
    "I am a passionate and innovative developer dedicated to crafting efficient and impactful solutions. With a strong foundation in computer science and a zeal for sustainability, I aim to bridge the gap between technology and real-world challenges.",
  github: "https://github.com/Amanw-25",
  resume:"https://drive.google.com/file/d/14Jko7XCizK5q3WurpwpKgHiRvqWKSjZ-/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/amanwairagkar/",
  leetcode: "https://leetcode.com/u/amanw-25/",
  // twitter: null, // No Twitter details in your resume
  // insta: null, // No Instagram details in your resume
  // facebook: null // No Facebook details in your resume
};

export const certificates = [
  {
    id: 1,
    name: "NPTEL - Computer Networks",
    issuer: "NPTEL",
    link: "https://drive.google.com/file/d/1imyqD_DOfYoOS9gtQMDASjiE722-r6uY/view?usp=sharing",
    image:
      "https://i.postimg.cc/Bbf6zgyX/Screenshot-from-2025-07-20-21-27-54.png",
  },
  {
    id: 1,
    name: "NPTEL - Database Management Systems",
    issuer: "NPTEL",
    link: "https://drive.google.com/file/d/12rphWvEequ9rpbNpck35vL-ZbtGAigpy/view?usp=sharing",
    image:
      "https://i.postimg.cc/TPZYy0TC/Screenshot-from-2025-07-20-21-28-29.png",
  },
  {
    id: 1,
    name: "Cisco Networking Certification",
    issuer: "Cisco",
    link: "https://drive.google.com/file/d/1DwVDA7zPLYulRwhRQR0Bb-X6ca4cYEMT/view?usp=sharing",
    image:
      "https://i.postimg.cc/fbw0P0L6/Screenshot-from-2024-11-24-23-11-24.png",
  },
  {
    id: 2,
    name: "Web Developer at GDSC",
    issuer: "Google",
    link: "https://drive.google.com/file/d/1m0vcjyLOXrYVudgcPpBhrQS-PfKeJ6H3/view?usp=sharing",
    image:
      "https://i.postimg.cc/JhvHzYKW/Screenshot-from-2024-11-24-23-18-00.png",
  },
  {
    id: 3,
    name: "Full Stack Web Development",
    issuer: "Apna College",
    link: "https://drive.google.com/file/d/1-ME_mlomHNGSFxvJUfvsFY0TnIwyMWSk/view?usp=sharing",
    image:
      "https://i.postimg.cc/Bb18FTY1/Screenshot-from-2024-11-24-23-12-22.png",
  },
  {
    id: 4,
    name: "Solution Challenge",
    issuer: "Google",
    link: "https://drive.google.com/file/d/1z-_DSG31rfiUTfr_1SdIPzQF_Oq2cn40/view?usp=sharing",
    image:
      "https://i.postimg.cc/wj9hCr4f/Screenshot-from-2024-11-24-23-15-36.png",
  },
  {
    id: 5,
    name: "C++ Training",
    issuer: "IIT Bombay",
    link: "https://drive.google.com/file/d/1U3057RPt9wVO8-DiRMFsxNaQUyVPqZQU/view?usp=sharing",
    image:
      "https://i.postimg.cc/BbY0JkcT/Screenshot-from-2024-11-24-23-25-04.png",
  },
  {
    id: 6,
    name: "Java Training",
    issuer: "IIT Bombay",
    link: "https://drive.google.com/file/d/1mG5Y8ECk6o2ItUTwabShHMi-4YZoFObC/view?usp=sharing",
    image:
      "https://i.postimg.cc/BbY0JkcT/Screenshot-from-2024-11-24-23-25-04.png",
  },
  {
    id: 7,
    name: "Python",
    issuer: "IIT Bombay",
    link: "https://drive.google.com/file/d/1yZw2OjNVcjp0UGJZrlxJJynv7PItS5Nt/view?usp=sharing",
    image:
      "https://i.postimg.cc/BbY0JkcT/Screenshot-from-2024-11-24-23-25-04.png",
  },

  // Add more certificates as needed
];

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "NestJS",
        image: "https://cdn.worldvectorlogo.com/logos/nestjs.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFcYJoetYqKxgVtDoFHN08qIF811Aglug-sw&s",
      },
      {
        name: "Adobe XD",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "https://i.postimg.cc/DmVztcMS/Eventory.jpg",
    role: "Full Stack Developer Intern",
    company: "Eventory",
    date: "July 2025 - Present",
    desc: "Contributing to the development of scalable web applications by building and maintaining frontend and backend modules. Collaborating with cross-functional teams to deliver efficient, maintainable code and improve overall user experience. Involved in code reviews, API integrations, and performance optimization.",
    skills: [
      "React.js",
      "Next.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux",
      "JavaScript",
      "REST APIs",
      "Git",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq7qnkckTd9LPqz39j_JKPTat85c_ICcoVLA&s",
    role: "Virtual Intern - Networking",
    company: "Cisco",
    date: "Aug 2024 - Sep 2024",
    desc: "Participated in Cisco's Virtual Internship program focusing on advanced networking concepts. Gained hands-on experience with network configuration, routing protocols, and troubleshooting techniques. Completed tasks and projects involving real-world network design simulations and optimization strategies.",
    skills: [
      "Networking",
      "Routing Protocols",
      "Network Design",
      "Troubleshooting",
      "Cisco Packet Tracer",
    ],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJW2h0_CF4v8csIaZDmssWDFMh9T7ROtruJw&s",
    role: "Web Developer Intern",
    company: "Youngovator",
    date: "Oct 2023 - Feb 2024",
    desc: "Built a website for Innovation Carnival 3.0 using HTML, CSS, and JavaScript to showcase projects by young innovators. Integrated Razorpay for event registration and payment processing, ensuring a seamless experience for participants.",
    skills: ["HTML", "CSS", "JavaScript", "Razorpay", "Web Development"],
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKIA20Yvir6-L_3K4piH9jCKpLxgXgHgQYwg&s",
    role: "Frontend Developer Intern",
    company: "Code Clause",
    date: "Sept 2023",
    desc: "Developed a basic chat application using WebSockets for real-time communication. Built the frontend with HTML, CSS, and JavaScript, while implementing backend functionality using Node.js and Express.js for efficient WebSocket handling.",
    skills: [
      "WebSockets",
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "Express.js",
    ],
  },
  {
    id: 5,
    img: "https://i.postimg.cc/6qbCkLvz/unnamed.png",
    role: "Core Team Member, Software Developer",
    company: "Computer Society of India (CSI) Club",
    date: "Oct 2023 - Oct 2024",
    desc: "As a Core Team Member and Software Developer at the Computer Society of India (CSI) Club, I have contributed to the development of various technical projects, collaborating with peers to deliver innovative solutions. I actively participate in organizing events like workshops, seminars, and hackathons, aimed at enhancing technical skills and fostering a learning environment within the club.",
    skills: [
      "Leadership",
      "Web Development",
      "Software Development",
      "Event Management",
      "Python",
      "JavaScript",
      "HTML",
      "CSS",
      "Git",
      "NodeJS",
    ],
  },
  {
    id: 6,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Co-Lead, Web Developer",
    company: "Google Developers Student Club (GDSC)",
    date: "Aug 2023 - Nov 2024",
    desc: "As a Co-Lead and Web Developer at the Google Developers Student Club (GDSC), I have led and collaborated on impactful projects with talented developers. My role also involves mentoring and guiding junior developers while contributing to the overall growth of the club. Through my involvement, I have organized and participated in hackathons, study jams, workshops, and technical events to foster a vibrant learning community.",
    skills: [
      "Leadership",
      "Web Development",
      "Mentorship",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
  {
    id: 7,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor",
    company: "GirlScript Summer of Code",
    date: "Oct 2024",
    desc: "Successfully contributed to HotWax by submitting a pull request that implemented key features or fixes, which was reviewed and merged into the codebase. Collaborated with maintainers and followed open-source best practices.",
  },
];

export const education = [
  {
    id: 0,
    img: "https://content.jdmagicbox.com/comp/bhopal/68/0755p755std90468/catalogue/acropolis-institute-of-technology-and-research-campus-ratibad-bhopal-engineering-colleges-3dmql4g.jpg",
    school: "Acropolis Institute of Technology & Research",
    date: "Nov 2022 - Jun 2026",
    grade: "CGPA: 8.30",
    desc: "I am currently pursuing a Bachelor's degree in Computer Engineering at Acropolis Institute of Technology & Research. I have completed 4 semesters with a CGPA of 8.20. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. I am also actively involved in the Google Developers Student Club (GDSC), where I work on various projects with a talented team of developers.",
    degree: "Bachelor of Technology - BTech, Computer Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPGYcPVzpuHcyv7rFOZfDMvCNH4FRjxNusrg&s",
    school: "Chamei Devi Public School",
    date: "Apr 2021 - Apr 2022",
    grade: "94.8%",
    desc: "I completed my class 12 high school education at Chamei Devi Public School , focusing on Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer Science",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPGYcPVzpuHcyv7rFOZfDMvCNH4FRjxNusrg&s",
    school: "Chamei Devi Public School",
    date: "Apr 2019 - Apr 2020",
    grade: "88.4%",
    desc: "I completed my class 10 education at Chamei Devi Public School, studying Science with Computer Applications.",
    degree: " CBSE (X), Science with Computer Applications",
  },
];

export const projects = [
  {
    id: 1,
    title: "Kisan Mitra",
    description:
      "An AI-driven platform for crop yield prediction, disease detection, and fertilizer recommendations. Features include multilingual website support (English, Hindi, Punjabi, Gujarati, and Marathi), Python-based voice bot for speech-to-text and text-to-speech, real-time community support via WebSocket, and live market prices with downloadable PDF reports.",
    image:
      "https://i.postimg.cc/qRt1YFDh/Screenshot-from-2024-11-24-21-55-00.png",
    tags: ["ReactJS", "NodeJS", "Express", "MongoDB", "Python"],
    category: "web app",
    github: "https://github.com/Amanw-25/Kissan-Mitra",
    link: "https://kissan-mitra.vercel.app/",
  },
  {
    id: 5,
    title: "Sustainify",
    description:
      "A sustainable living guide offering eco-friendly product recommendations, personalized tips, and carbon footprint tracking. Uses ReactJS, NodeJS, MongoDB, and Mistral AI (LLM) for intelligent user-specific recommendations. Features secure authentication with JWT and dynamic content updates via RESTful APIs.",
    image:
      "https://i.postimg.cc/g0zbzVR4/Screenshot-from-2025-03-01-18-19-57.png",
    tags: ["ReactJS", "NodeJS", "MongoDB", "JWT", "RESTful API"],
    category: "web app",
    github: "https://github.com/Amanw-25",
    link: "https://sustainify-v2.vercel.app/",
  },
  {
    id: 2,
    title: "VitalLink",
    description:
      "Developed a dynamic appointment booking system with React, Node.js, and MongoDB. The app allows users to view their upcoming appointments, retrieve doctor details, and manage bookings effortlessly. Features include a responsive UI, real-time data fetching, and secure authentication for user-specific data access.",
    image:
      "https://i.postimg.cc/sg4g1fnC/Screenshot-from-2025-01-12-00-27-39.png",
    tags: ["React", "Node.js", "MongoDB", "REST API", "Frontend Development"],
    category: "web app",
    github: "https://github.com/Amanw-25/VitalLink",
    link: "https://vitals-link.vercel.app/",
  },
  {
    id: 3,
    title: "CII Website",
    description:
      "Developed the official website for a government and industry collaboration event, focusing on promoting innovation and business partnerships. Built with ReactJS for a dynamic and responsive user experience, with a backend powered by NodeJS, Express, and MongoDB for efficient data management. Key features include seamless navigation, real-time updates, and accessibility for multilingual users.",
    image:
      "https://i.postimg.cc/FF64Y5Xq/Screenshot-from-2024-11-24-22-02-56.png",
    tags: ["ReactJS", "NodeJS", "Express", "MongoDB"],
    category: "web app",
    github: "https://github.com/Amanw-25/CII-Webiste",
    link: "https://cii-delta.vercel.app/",
  },
  {
    id: 4,
    title: "Travel-Nest",
    description:
      "A hotel discovery platform with location and amenities search. Built with JS and EJS for frontend and templating, and integrated backend functionality using NodeJS, ExpressJS, and MongoDB. Features include Google Maps API integration and RESTful APIs for real-time reviews and data.",
    image:
      "https://i.postimg.cc/JzmdnP0v/Screenshot-from-2024-11-24-21-51-10.png",
    tags: ["NodeJS", "ExpressJS", "MongoDB", "JavaScript", "EJS"],
    category: "web app",
    github: "https://github.com/Amanw-25/Wander-Stay",
    link: "https://travel-plan-jqt4.onrender.com/listings",
  },
  {
    id: 6,
    title: "Innovation Carnival Website",
    description:
      "Built a website for Innovation Carnival 3.0 with HTML, CSS, and JavaScript, enabling young innovators to showcase their projects. Integrated Razorpay payment gateway for smooth event registration and participation.",
    image:
      "https://i.postimg.cc/MT8c2Md7/Screenshot-from-2024-11-24-21-59-54.png",
    tags: ["HTML", "CSS", "JavaScript", "Razorpay"],
    category: "web app",
    github: "https://github.com/Amanw-25/InnovationCarnival-3.0",
    link: "https://innovationcarnival.in/",
  },
];




